<template>
    <div class="row">
        <div id="volumeSpinner"></div>
        <div class="e-card mt-2">
            <div class="row">
                <div class="col-sm-2 mt-3">
                    <ejs-dropdownlist ref='dplTypeVolume' id="typeVolume" name="typeVolume" :change='onTypeVolumeChange' floatLabelType='Auto' :dataSource='productsVolume' :fields="{text: 'name', value: 'id' }" :index='typeIndex' placeholder="Product:" :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                </div>
                <div class="col-sm-2 mt-3">
                    <ejs-dropdownlist ref='dplPriceAreaVol' id="priceAreaVol" name="priceAreaVolName" :actionComplete="onActionComplete" v-if="showPriceAreaSection" :index='typeIndex' :change='onPriceAreaVolChange' floatLabelType='Auto' :dataSource='priceAreaVol' :fields="{text: 'name', value: 'id' }" placeholder="Price Area:" :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                </div>
                <div class="col-sm-5 check-vol">
                  
                </div>
                <div class="col-sm-2 mt-3">
                    <ejs-button cssClass="e-primary btn-download" v-on:click.native='btnVolumeReportDownload'>Volume Report</ejs-button>
                </div>
            </div>
            <div class="row">
                <div class="col m-3" v-if="showGrid">
                    <ejs-grid ref='grid'
                              :dataSource='gridData'
                              :filterSettings='filterOptions'
                              :allowPaging='false'
                              :allowResizing='true'
                              :allowReordering='false'
                              :allowSorting='false'
                              :allowFiltering='true'
                              :autoFit='true'
                              :toolbarClick='toolbarClick'
                              :toolbar='toolbar'
                              :actionBegin='actionBegin'
                              :actionComplete='actionComplete'
                              :actionFailure='actionFailure'
                              :queryCellInfo='customiseCell'>
                        <e-columns>
                            <e-column field='monthName' headerText='Month' width=120></e-column>

                            <e-column headerText='therms' :columns='thermsColumnes' textAlign="Center"></e-column>
                            <e-column headerText='th/d' :columns='thdColumnes' textAlign="Center"></e-column>
                            <e-column headerText='kWh' :columns='kWhColumnes' textAlign="Center"></e-column>

                            <e-column headerText='%' :columns='PercentageColumnes' textAlign="Center"></e-column>


                        </e-columns>
                    </ejs-grid>
                </div>
                    <div class="col m-3" v-if="showGridel">
                        <ejs-grid ref='gridel'
                                  :dataSource='gridData'
                                  :filterSettings='filterOptions'
                                  :allowPaging='false'
                                  :allowResizing='true'
                                  :allowReordering='false'
                                  :allowSorting='false'
                                  :allowFiltering='true'
                                  :autoFit='true'
                                  :toolbarClick='toolbarClick'
                                  :toolbar='toolbar'
                                  :actionBegin='actionBegin'
                                  :actionComplete='actionComplete'
                                  :actionFailure='actionFailure'
                                  :queryCellInfo='customiseCell'>
                            <e-columns>
                                <e-column field='monthName' headerText='Month' width=120></e-column>

                                <e-column headerText='MW' :columns='MWColumnes' textAlign="Center"></e-column>
                                <e-column headerText='MWh' :columns='MWhColumnes' textAlign="Center"></e-column>
                                <e-column headerText='kWh' :columns='kWhColumnes' textAlign="Center"></e-column>

                                <e-column headerText='%' :columns='PercentageColumnes' textAlign="Center"></e-column>


                            </e-columns>
                        </ejs-grid>
                    </div>
                </div>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import { GridPlugin, Toolbar, Filter, Edit, Resize } from "@syncfusion/ej2-vue-grids";
    import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
    import { DialogPlugin } from '@syncfusion/ej2-vue-popups';
    import { TextBoxPlugin } from "@syncfusion/ej2-vue-inputs";
    import apis from '../../common/network'
    import urls from '../../common/urls';
    import authToken from '../../common/authToken';
    import gridOptions from '../../common/gridOptions'
    import { Query } from '@syncfusion/ej2-data';
    import store from '../../store';
    import router from '../../router/index';
    import { ToastPlugin, Toast } from "@syncfusion/ej2-vue-notifications";
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';
    import { isNullOrUndefined } from '@syncfusion/ej2-base';
    import { DialogUtility } from '@syncfusion/ej2-vue-popups';
    import SyncHelper from '../../common/syncfusion';

    Vue.use(ButtonPlugin);
    Vue.use(DialogPlugin);
    Vue.use(TextBoxPlugin);
    Vue.use(GridPlugin);

    export default {
        name: 'VolumeReport',
        created() {
            apis.protectedApi(`utils/products?contractId=${store.state.reportContractId}&includeCombined=true`).then(it => {
                this.productsVolume = it.data;
            })
                .catch(
                    response => {
                        var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                        gridOptions.errorAlert("Error: " + message);
                    }
                );

        },
        data() {
            return {
                gridData: {},
                typeIndex: 0,
                unit: null,
                showGridel: false,
                showGrid: false,
                showPriceAreaSection: false,
                gridDataResultsArea: null,
                gridDataResultsAreaSystem: null,
                gridDataBase: null,
                gridDataPeak: null,
                gridDataOffpeak: null,
                gridDataGas: null,
                gridDataCombined: null,
                productsVolume: [],
                priceAreaNames: store.state.pricingAreaNames,
                MWColumnes: [
                    {
                        field: 'totalMW',
                        headerText: 'Total',
                        textAlign: 'Center',
                        width: "120",
                        format: "n2" 
                    },
                    {
                        field: 'fixedMW',
                        headerText: 'Fixed',
                        textAlign: 'Center',
                        width: "120",
                        format: "n2" 
                    },
                    {
                        field: 'openMW',
                        headerText: 'Open',
                        textAlign: 'Center',
                        width: "120",
                        format: "n2" 
                    }
                ],
                MWhColumnes: [
                    {
                        field: 'totalMWh',
                        headerText: 'Total',
                        textAlign: 'Center',
                        width: "120",
                        format: "n2" 
                    },
                    {
                        field: 'fixedMWh',
                        headerText: 'Fixed',
                        textAlign: 'Center',
                        width: "120",
                        format: "n2" 
                    },
                    {
                        field: 'openMWh',
                        headerText: 'Open',
                        textAlign: 'Center',
                        width: "120",
                        format: "n2" 
                    }
                ],
                kWhColumnes: [
                    {
                        field: 'totalKWh',
                        headerText: 'Total',
                        textAlign: 'Center',
                        width: "120",
                        format: "n2" 
                    },
                    {
                        field: 'fixedKWh',
                        headerText: 'Fixed',
                        textAlign: 'Center',
                        width: "120",
                        format: "n2" 
                    },
                    {
                        field: 'openKWh',
                        headerText: 'Open',
                        textAlign: 'Center',
                        width: "120",
                        format: "n2" 
                    }
                ],
                thermsColumnes: [
                    {
                        field: 'totalTherms',
                        headerText: 'Total',
                        textAlign: 'Center',
                        width: "120",
                        format: "n2" 
                    },
                    {
                        field: 'fixedTherms',
                        headerText: 'Fixed',
                        textAlign: 'Center',
                        width: "120",
                        format: "n2" 
                    },
                    {
                        field: 'openTherms',
                        headerText: 'Open',
                        textAlign: 'Center',
                        width: "120",
                        format: "n2" 
                    }
                ],
                thdColumnes: [
                    {
                        field: 'totalThd',
                        headerText: 'Total',
                        textAlign: 'Center',
                        width: "120",
                        format: "n2" 
                    },
                    {
                        field: 'fixedThd',
                        headerText: 'Fixed',
                        textAlign: 'Center',
                        width: "120",
                        format: "n2" 
                    },
                    {
                        field: 'openThd',
                        headerText: 'Open',
                        textAlign: 'Center',
                        width: "120",
                        format: "n2" 
                    }
                ],
                m3Columnes: [
                    {
                        field: 'totalM3',
                        headerText: 'Total',
                        textAlign: 'Center',
                        width: "120",
                        format: "n2" 
                    },
                    {
                        field: 'fixedM3',
                        headerText: 'Fixed',
                        textAlign: 'Center',
                        width: "120",
                        format: "n2" 
                    },
                    {
                        field: 'openM3',
                        headerText: 'Open',
                        textAlign: 'Center',
                        width: "120",
                        format: "n2" 
                    }
                ],
                PercentageColumnes: [
                    {
                        field: 'fixedPercentage',
                        headerText: 'Fixed',
                        textAlign: 'Center',
                        width: "120",
                        format: "n2"
                    },
                    {
                        field: 'openPercentage',
                        headerText: 'Open',
                        textAlign: 'Center',
                        width: "120",
                        format: "n2"
                    }
                ],
                toolbar: [],
                filterOptions: gridOptions.filterSettings,
                allowFiltering: true,
               
            }
        },

        methods: {
            onActionComplete(args) { //initial load to be set on the first pricing area
                let productName = document.getElementById('typeVolume').value;
                if (args.result && args.result.length > 0) {
                    this.updateTypeToShow(productName, args.result[0].id,false);
                }
            },
            onTypeVolumeChange: function (args) {
                let pricingAreaId = document.getElementById('priceAreaVol')?.ej2_instances[0]?.value;             
                this.updateTypeToShow(args.itemData.name, pricingAreaId, false)
            },
            onPriceAreaVolChange: function (args) {
                if (args.isInteracted) {
                    let productName = document.getElementById('typeVolume').value;
                    this.updateTypeToShow(productName, args.itemData == null ? null : args.itemData.id, false)
                }
            },
            onCheckPASystemVol(args) {
                let pricingAreaId = document.getElementById('priceAreaVol')?.ej2_instances[0]?.value;
                let productName = document.getElementById('typeVolume').value;
               
                    this.updateTypeToShow(productName, pricingAreaId, false)
                
            },
            toolbarClick(args) {
              
            },
            updateTypeToShow: function (proudctName, pricingAreaId, priceSystem) {
                if (proudctName == "Combined") {
                    this.gridData = this.gridDataCombined;
                    if (pricingAreaId != null) {
                        if (priceSystem) {
                            this.gridData = this.gridDataResultsAreaSystem.filter(b => b.productName == proudctName && b.pricingAreaId == pricingAreaId)[0].data
                        } else {
                            this.gridData = this.gridDataResultsArea.filter(b => b.productName == proudctName && b.pricingAreaId == pricingAreaId)[0].data
                        }

                    }
                }
                if (proudctName == "Baseload") {
                    this.gridData = this.gridDataBase;
                    if (pricingAreaId != null) {
                        if (priceSystem) {
                            this.gridData = this.gridDataResultsAreaSystem.filter(b => b.productName == proudctName && b.pricingAreaId == pricingAreaId)[0].data
                        } else {
                            this.gridData = this.gridDataResultsArea.filter(b => b.productName == proudctName && b.pricingAreaId == pricingAreaId)[0].data
                        }
                    }
                }

                if (proudctName == "Peakload") {
                    this.gridData = this.gridDataPeak;
                    if (pricingAreaId != null) {
                        if (priceSystem) {
                            this.gridData = this.gridDataResultsAreaSystem.filter(b => b.productName == proudctName && b.pricingAreaId == pricingAreaId)[0].data
                        } else {
                            this.gridData = this.gridDataResultsArea.filter(b => b.productName == proudctName && b.pricingAreaId == pricingAreaId)[0].data
                        }
                    }
                }
                if (proudctName== "Off-peak") {
                    this.gridData = this.gridDataOffpeak;
                    if (pricingAreaId != null) {
                        if (priceSystem) {
                            this.gridData = this.gridDataResultsAreaSystem.filter(b => b.productName == proudctName && b.pricingAreaId == pricingAreaId)[0].data
                        } else {
                            this.gridData = this.gridDataResultsArea.filter(b => b.productName == proudctName && b.pricingAreaId == pricingAreaId)[0].data
                        }
                    }
                }


            },
            getVolumeData: function (pricingAreaId, priceAreaSystem) {
                showSpinner(document.getElementById('mainSpinner'));
                this.showPriceAreaSection = this.priceAreaNames == undefined ? false : true;
                apis.protectedApi(`report/volumeReport/${store.state.reportContractId}?pricingAreaId=${pricingAreaId == undefined ? "" : pricingAreaId}&priceAreaSystem=${priceAreaSystem == undefined ? false : priceAreaSystem}`)
                    .then(response => {
                        hideSpinner(document.getElementById('volumeSpinner'));
                        this.gridDataResultsArea = response.data.result.areas;
                        this.gridDataResultsAreaSystem = response.data.result.areasWithSystem;
                        this.gridDataBase = response.data.result.base;
                        this.gridDataPeak = response.data.result.peak;
                        this.gridDataOffpeak = response.data.result.offPeak;
                        this.gridDataGas = response.data.result.gas;
                        this.gridDataCombined = response.data.result.combined;
                        this.gridData = response.data.result.combined;
                        this.isGas = response.data.isGas;
                        if (this.isGas) {
                            this.showGrid = true;
                        } else {
                            this.showGridel = true;
                        }
                        let productName = document.getElementById('typeVolume').value;
                        let pricingAreaId = document.getElementById('priceAreaVol')?.ej2_instances[0]?.value;
                        this.updateTypeToShow(productName, pricingAreaId, false)
                        hideSpinner(document.getElementById('mainSpinner'));
                    }).catch(e => {
                        hideSpinner(document.getElementById('volumeSpinner'));
                        hideSpinner(document.getElementById('mainSpinner'));
                        if (e.response) {
                            this.showErrorDialog(e.response.data.message);
                        }
                    })
            },
            btnVolumeReportDownload: function (args) {
                showSpinner(document.getElementById('volumeSpinner'));
                showSpinner(document.getElementById('mainSpinner'));
                apis.protectedApi(`${urls.apiBaseUrl}reportTemplate/generateVolumeReportPage/${store.state.reportContractId}`).then(it => {
                    window.open(it.data.reportUri);
                    hideSpinner(document.getElementById('volumeSpinner'));
                    hideSpinner(document.getElementById('mainSpinner'));
                }).catch(
                    response => {
                        hideSpinner(document.getElementById('volumeSpinner'));
                        hideSpinner(document.getElementById('mainSpinner'));
                        var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                        gridOptions.errorAlert("Error: " + message);
                    }
                );
            },
            setToolbarVisibility: function () {
               
            },
            showErrorDialog: function (message) {
                DialogUtility.alert({
                    title: 'Alert Dialog',
                    content: message,
                    position: { X: 700, Y: 200 },
                    showCloseIcon: true,
                    closeOnEscape: true,
                    animationSettings: { effect: 'Zoom' },
                    zIndex: 1100
                });
            },
            customiseCell: function (args) {
               
            },
            actionBegin(args) {
                gridOptions.actionBegin(args, this.$refs);
             

            },
            actionComplete(args) {
                gridOptions.actionComplete(args, this.$refs);
            },
            actionFailure(args) {
                gridOptions.actionFailure(args, this.$refs);
            }
        },
        mounted() {
            let spinner = document.getElementById('volumeSpinner');
            createSpinner({
                target: spinner
            });
            showSpinner(spinner);
            this.getVolumeData();
            this.setToolbarVisibility();
          
        },
        computed: {
            priceAreaVol() {
                return SyncHelper.getDataManager("utils/pricingContractAreas?contractId=" + store.state.reportContractId);
            }
        },
        provide: {
            grid: [Edit, Filter, Toolbar, Resize]
        }
    }
</script>

<style>
    .btn-download {
        float: right;
        margin-top: 23px;
    }
    .check-vol {
        padding-top: 2.3rem;
    }
#volumeSpinner {
    display:none;
}
</style>